import { enableAutoinvestmentsModeEpic } from 'components/features/rewards/rewardsPane/store/epics/autoInvestmentsMode/enableAutoinvestmentsMode'
import { combineEpics } from 'redux-observable'

export const rewardsPaneAutoinvestmentsModeEpic = combineEpics(
  enableAutoinvestmentsModeEpic,
)
